export type OnboardingRole = 'admin' | 'manager' | 'user' | 'external'

export type OnboardingItemKey =
  | 'workday'
  | 'invite_team'
  | 'first_client'
  | 'first_project'
  | 'first_task'
  | 'first_time_entry'
  | 'see_my_tasks'
  | 'see_team'
  | 'review_settings'
  | 'meet_rushmind'

export type OnboardingItem = {
  key: OnboardingItemKey
  // Item manual: sem dado no sistema que o prove, o usuário marca ao clicar na ação.
  manual: boolean
  done: boolean
  done_at: string | null
  // Pré-requisito que ainda falta para o item poder ser feito (ex.: tarefa exige cliente e projeto).
  locked_reason: OnboardingLockReason | null
}

export type OnboardingLockReason = 'needs_client' | 'needs_project' | 'needs_task'

export type OnboardingProgress = {
  role: OnboardingRole
  items: OnboardingItem[]
  done_count: number
  total: number
  dismissed: boolean
  completed: boolean
}

export type WorkingDayForm = {
  cost_hour: number
  shift_time: string
  workdays: Array<string>
}

export const initialWorkingDay: WorkingDayForm = {
  cost_hour: 0,
  shift_time: '',
  workdays: [],
}
